import { parseEntityId } from "./id-parser";
// 61c378dc-f1d8-5555-bbbb-3bd5ab1ca32b
export const CrmAuthorId = parseEntityId("61c378dcf1d83bd5ab1ca32b");
export const rootRegionParentId = parseEntityId("2c57076a-5a1c-4afc-b246-0a0b580e9c68");
//# sourceMappingURL=constants.js.map